import Nullstack from 'nullstack';
export default function IconZodiacLeo({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-zodiac-leo",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M13 17a4 4 0 1 0 8 0"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "16",
    r: "3"
  }), "   ", Nullstack.element("circle", {
    cx: "11",
    cy: "7",
    r: "4"
  }), "   ", Nullstack.element("path", {
    d: "M7 7c0 3 2 5 2 9"
  }), "   ", Nullstack.element("path", {
    d: "M15 7c0 4 -2 6 -2 10"
  }), " ");
}